/**
 * Selección de "vecinos" para la página de atleta (protagonista + contexto).
 *
 * Regla de negocio (Riki, 2026-07-09): sobre la clasificación YA ORDENADA por
 * puesto, se muestra al atleta EN GRANDE (protagonista) y SIEMPRE 2 tarjetas
 * de contexto:
 *   - en medio  → el del puesto inmediatamente superior y el inferior.
 *   - si es 1º  → el 2º y el 3º (no hay superior).
 *   - si es último → los dos de encima (no hay inferior).
 * Si la prueba tiene menos de 3 atletas, se muestran los que haya.
 *
 * Puro (sin React): recibe el nº de atletas y el índice del protagonista y
 * devuelve los índices a pintar en orden de puesto + cuál es el protagonista.
 */
export interface SeleccionVecinos {
  /** Índices (en el array ordenado por puesto) a pintar, en orden ascendente. */
  indices: number[];
  /** Posición del protagonista DENTRO de `indices` (0, 1 o 2). */
  protagonistaEnFila: number;
}

/**
 * @param n  nº de atletas en la clasificación (>= 1)
 * @param i  índice del protagonista en el array ordenado por puesto (0-based)
 */
export function elegirVecinos(n: number, i: number): SeleccionVecinos {
  if (n <= 0 || i < 0 || i >= n) {
    return { indices: i >= 0 && i < n ? [i] : [], protagonistaEnFila: 0 };
  }
  // Ventana de 3 (protagonista + 2 de contexto) recolocada para no salirse:
  // si el protagonista está pegado a un borde, la ventana se desplaza hacia
  // el lado disponible (1º → [0,1,2]; último → [n-3,n-2,n-1]).
  const ancho = Math.min(3, n);
  let inicio = i - 1;
  if (inicio < 0) inicio = 0;
  if (inicio + ancho > n) inicio = n - ancho;
  const indices: number[] = [];
  for (let k = inicio; k < inicio + ancho; k++) indices.push(k);
  return { indices, protagonistaEnFila: i - inicio };
}
